import {Exclude, Expose, instanceToPlain, plainToInstance, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {TransportAssocEntity, TransportAssocValidator} from "./transport-assoc";

export const TtaMappedPairValidator = t.intersection([
  t.type({

  }),
  t.partial({
    importTta: TransportAssocValidator,
    databaseTta: TransportAssocValidator,
    importData: t.record(t.string, t.string)
  }),
]);

export const TtaMappedPairArrayValidator = t.array(TtaMappedPairValidator);

export type TtaMappedPair = t.TypeOf<typeof TtaMappedPairValidator>;
export type TtaMappedPairArray = t.TypeOf<typeof TtaMappedPairArrayValidator>;

@Exclude()
export class TtaMappedPairEntity {
  @Expose({name: "importTta"})
  @Type(() => TransportAssocEntity)
  tta?: TransportAssocEntity;

  @Expose({name: "importData"})
  data?: Record<string, string | undefined>

  @Expose({name: "databaseTta"})
  @Type(() => TransportAssocEntity)
  dbTta?: TransportAssocEntity;

  /**
   * Constructor for TtaMappedPairEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: TtaMappedPair): TtaMappedPairEntity {
    return plainToInstance(TtaMappedPairEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<TtaMappedPair> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(TtaMappedPairValidator, object);
  }

  asTypeValue(): TtaMappedPair {
    return validateJSONNow(TtaMappedPairValidator, this.plain());
  }

  plain(): Record<string, any> {
    return instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
  }
}
